import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import AutoCompleteInput from "../common/input/AutocompleteInput";
import MiniSpinner from "../common/MiniSpinner";
import Spinner from "../common/spinner";
import { getMatchingTerms } from "../../api/typeaheadApi";

class MiniSearch extends React.Component {

    constructor() {
        super();

        this.state = {
            kItems: [],
            keywordLoading: false,
            keywordNoResults: false,
            keyword: "",
            processing: false
        };

        this.kTime = 0;
        this.addFavorite = this.addFavorite.bind(this);
        this.stopProcessing = this.stopProcessing.bind(this);
        this.onFavorited = this.onFavorited.bind(this);
        this.loadKeywordTypeahead = this.loadKeywordTypeahead.bind(this);
        this.isAlreadyFavorited = this.isAlreadyFavorited.bind(this);
    }

    isAlreadyFavorited(npi) {
        return this.props.existingFavoriteNpis.filter((fav, i) => fav === npi).length > 0;
    }

    loadKeywordTypeahead(val) {
        this.setState({ kItems: [], keywordLoading: true });
        let dt = new Date();
        let aco = this.props.acoList && this.props.acoList.length > 0 ? this.props.acoList[0] : "";
        const { hasSWHP } = this.props;

        getMatchingTerms({ term: val, returnAll: false, networkCode: this.props.networkCode, acoAlliance: aco, practiceGroup: hasSWHP ? "SWHP" : "" }, dt.valueOf())
            .then(json => {
                if (this.kTime < json.timestamp) {
                    this.kTime = json.timestamp;
                    let items = [];
                    let lastCategory = "";
                    json = json.results;
                    if (json) {
                        for (var term in json) {
                            if (json[term].values) {
                                if (json[term].name === "Doctors") {
                                    for (var i = 0; i < json[term].values.length; i++) {
                                        var val = json[term].values[i];
                                        if (!this.isAlreadyFavorited(val.npi)) {
                                            items.push({ id: val.npi, label: val.searchDisplayName });
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.setState({ kItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0) });
                }
            });
    }

    addFavorite(val, item) {
        this.setState({ processing: true });

        const npi = item.id;
        this.props.addProviderToFavorites(npi, this.stopProcessing);
    }

    stopProcessing() {
        this.setState({
            processing: false,
            keyword: "",
            kItems: [],
            keywordLoading: false,
            keywordNoResults: false
        });

        this.onFavorited();
    }

    onFavorited() {
    }

    render() {
        return (
            <React.Fragment>
                <AutoCompleteInput
                    value={this.state.keyword}
                    placeholder="Select a doctor to add to favorites"
                    prependIcon="icon-search"
                    loading={this.state.keywordLoading}
                    noResults={this.state.keywordNoResults}
                    itemList={this.state.kItems}
                    autoHighlight={false}
                    onChange={(e, value) => {
                        if (e) {
                            this.setState({ keyword: e.target.value });
                            this.loadKeywordTypeahead(value);
                        }
                        else {
                            // can't use AutoCompleteInput's onClickClear...
                            this.setState({ keyword: "" });
                        }
                    }}
                    onSelect={this.addFavorite}
                />
                {
                    this.state.processing &&
                    <Spinner />
                }
            </React.Fragment>    
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let aco = [];
    let npis = [];

    if (ownProps.existingFavorites && ownProps.existingFavorites.length > 0) {
        for (var i = 0; i < ownProps.existingFavorites.length; i++) {
            const provs = ownProps.existingFavorites[i];
            if (provs && provs.length > 0) {
                // why nest this???
                for (var j = 0; j < provs.length; j++) {
                    npis.push(provs[j].npi);
                }
            }
        }
    }

    if (state.sso && state.sso.userDetails) {
        if (state.sso.userDetails.ACO && state.sso.userDetails.ACO !== "") {
            aco = state.sso.userDetails.ACO.split(",");
        }
    }
    
    return {
        networkCode: state.session.networkCode,
        acoList: aco,
        existingFavoriteNpis: npis,
        hasSWHP: state.memberships.hasAnySWHP,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addProviderToFavorites: (npi, completionCallback) => {
            dispatch({
                type: types.ADD_FAVORITE_PROVIDER_START,
                npi: npi,
                completionCallback: completionCallback
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniSearch);
